import React from "react";
import styles from "./SkeletonApply.module.css";

const SkeletonApply = () => {
    return (
        <div className={styles.skeletonContainer}>
            <div className={styles.skeletonHeader}></div>
            
            <div className={styles.skeletonInput}></div>
            
            <div className={styles.skeletonFooter}>
                <div className={styles.skeletonCheckbox}></div>
                <div className={styles.skeletonButton}></div>
            </div>
        </div>
    );
};

export default SkeletonApply;